export default __webpack_public_path__ + "img/1_7-2e3221a9.png";